import { API_METHODS, createApiFunction } from './apiProvider'

const PATH = 'v1/auth'

export const getCurrentAccountApi = (pricingCountry: string) =>
  createApiFunction(
    API_METHODS.GET,
    `${PATH}/currentAccount?pricingCountry=${pricingCountry}`,
    null,
    true
  )
export const activateAccountApi = () =>
  createApiFunction(API_METHODS.POST, `${PATH}/activateAccount`, null, true)
export const updateAccountApi = (account: any) =>
  createApiFunction(API_METHODS.PUT, 'accounts', account, true)
export const signUpUser = (email: any) =>
  createApiFunction(API_METHODS.POST, `${PATH}/createUserCognito`, email)
